import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { queriesApi } from "../../app/slices/queriesSlice";
import { createMRTColumnHelper } from "material-react-table";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import CustomTable from "../../components/customTable/CustomTable";
import { mobilequeriesApi } from "../../app/slices/mobileQueriesSlice";
import { Box } from "@mui/material";

export default function MobileQueries() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(mobilequeriesApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector(
    (state) => state.mobileQueries.mobileQueries.data
  );
  const stateLoading = useSelector((state) => state.mobileQueries.loading);
  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>{cell.row.original?.name}</div>
      ),
    }),
    columnHelper.accessor("phone_number", {
      header: "Mobile No",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.phone_number || "N/A"}
        </div>
      ),
    }),

    columnHelper.accessor("raise_a_query", {
      header: "Message",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original?.raise_a_query || "N/A"}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "left" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  return (
    <>
      <DateSearchComponent onSearch={handleSearch} />
        <Box mt={2} >

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="Queries"
      />
      </Box>
    </>
  );
}
